import { Box, Container } from '@mui/material'
import React from 'react'

type TProps = {
  containerProps?: React.ComponentProps<typeof Container>
  children: React.ReactNode
} & React.ComponentProps<typeof Box>

function PageLayout({ children, containerProps = {}, ...props }: TProps) {
  return (
    <Box {...props}>
      <Container {...containerProps}>{children}</Container>
    </Box>
  )
}

export default PageLayout
